import { Controller } from "@hotwired/stimulus"

// Toggles which payment method preview is shown based on the selected payment
// method, and reprices the amount options to that method's pricing type.
//
// The method input is a <select> for admins and a radio group — or a lone
// hidden field when there is only one method — in the customer portal, so the
// selection is read off whichever element currently carries it.
export default class extends Controller {
  static targets = ["amount", "method", "prefill", "preview"]

  connect() {
    this.update()
  }

  update() {
    const selection = this.selection
    if (!selection) return

    this.previewTargets.forEach((preview) => {
      const matches = preview.dataset.tokenizedPaymentAccountId === selection.value
      preview.classList.toggle("hidden", !matches)
    })

    this.amountTargets.forEach((amount) => {
      amount.classList.toggle("hidden", amount.dataset.pricingTypeId !== selection.pricingTypeId)
    })

    this.prefillTargets.forEach((prefill) => {
      const amount = JSON.parse(prefill.dataset.amounts)[selection.pricingTypeId]
      if (amount === undefined) return

      prefill.dataset.amount = amount
      if (prefill.checked) {
        prefill.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
  }

  get selection() {
    // A <select> reports type "select-one", so only unchecked radios are skipped.
    const method = this.methodTargets.find((target) => target.type !== "radio" || target.checked)
    // The admin <select> carries its pricing type on the chosen <option>; a
    // radio or the lone hidden field carries it on the input itself.
    const source = method?.tagName === "SELECT" ? method.selectedOptions[0] : method
    if (!source) return null

    return { pricingTypeId: source.dataset.pricingTypeId, value: method.value }
  }
}
